import { render, staticRenderFns } from "./modal_agregarNorma.vue?vue&type=template&id=3a2db06e&"
import script from "./modal_agregarNorma.vue?vue&type=script&lang=js&"
export * from "./modal_agregarNorma.vue?vue&type=script&lang=js&"
import style0 from "./modal_agregarNorma.vue?vue&type=style&index=0&id=3a2db06e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports